// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__q9HyF","rootNoMargin":"styles_rootNoMargin__3w1sh"};